export default __webpack_public_path__ + "static/media/Snd_O_Starts.6fdf29bb.mp3";